import { createFileRoute } from '@tanstack/react-router'
import { PolicyEditor } from '@/components/admin/PolicyEditor'

export const Route = createFileRoute('/_app/org/policies/new')({
  component: NewPolicyPage,
})

function NewPolicyPage() {
  return <PolicyEditor />
}
